<div class="request-error-snack" role="alert">
  <div class="request-error-snack__content">
    <strong class="request-error-snack__title">{{ data.title }}</strong>
    <div class="request-error-snack__detail">{{ data.detail }}</div>
  </div>
  <button class="request-error-snack__close" type="button" [attr.aria-label]="'errors.close' | translate" (click)="snackBarRef.dismiss()">
    ×
  </button>
</div>
